import { IIFramesState } from '@/@types'

const state: IIFramesState = {
  iframesRendered: {},
  playingIFrameId: '',
}

export default state
